export default __webpack_public_path__ + "static/media/psychological-conditions.fd0ae769.svg";